import { CHANGE_CAMERA, CHANGE_MOUSE } from '../state/editor/modules/ui/preview/actions.js';
import { updateInteraction as updateInteractionUI } from '../state/editor/modules/ui/actions.ts';
import {
    CHANGE_EFFECT,
    UPDATE_SELECTION,
    UPDATE_VIEW,
    UPDATE_VIEW_POSITION,
    UPDATE_VIEW_SCALE,
} from '../state/editor/modules/project/design/tiling/actions.js';
import {
    UPDATE_LAYER_ROTATION,
    UPDATE_LAYER_SCALE,
    UPDATE_LAYER_SELECTION,
} from '../state/editor/modules/project/design/tiling/actions.layer.js';
import { updateScenes } from '../state/regl/modules/scenes/actions.ts';
import { updateInteraction, updateMouse } from '../state/regl/modules/ui/actions.ts';

// we blacklist some actions that get executed every frame, as to keep the interface responsive
// in dev mode
export const actionsDenylist = [
    // EDITOR route
    CHANGE_MOUSE,
    updateInteractionUI.type,
    UPDATE_VIEW_POSITION,
    CHANGE_CAMERA,
    UPDATE_SELECTION,
    UPDATE_VIEW_SCALE,
    UPDATE_VIEW,
    CHANGE_EFFECT,
    // EDITOR layers
    UPDATE_LAYER_SELECTION,
    UPDATE_LAYER_SCALE,
    UPDATE_LAYER_ROTATION,

    // REGL test route
    updateScenes.type,
    updateInteraction.type,
    updateMouse.type,
];
